import { AppConfig } from '@tcs/client-portal/types/AppConfig';
import { createContext, ReactNode } from 'react';

interface ContextProps {
  config: AppConfig;
}

interface Props {
  children: ReactNode;
  config: AppConfig;
}

export const ConfigContext = createContext<ContextProps>({
  config: undefined,
});

const ConfigProvider = ({ children, config }: Props) => {
  return (
    <ConfigContext.Provider
      value={{
        config,
      }}>
      {children}
    </ConfigContext.Provider>
  );
};

export default ConfigProvider;
